$(function () {
  $(".develop-content-nav li")
    .first()
    .find(".content-nav-line")
    .addClass("line-hover");
  $(".wisdom").first().css("display", "flex");
  /********菜单导航栏切换***********/
  $(".develop-content-nav").on("click", "li", function () {
    // console.log('this', $(this).index())
    $(".develop-content-nav li")
      .find(".content-nav-line")
      .removeClass("line-hover");
    $(this).find(".content-nav-line").addClass("line-hover");
    $(".wisdom").css("display", "none");
    $(".wisdom").eq($(this).index()).css("display", "flex");
  });
});
